module.exports = __webpack_public_path__ + "static/media/pain-condition-intake@3x.0e28d8c8.png";